import gql from "graphql-tag";

const REGIONAL_DIRECTORS_QUERY = gql`
query GetRegionalDirectors {
    regionalDirectors {
        lookup_id
        first_name
        last_name
        phone
        group
        name
        event_coordinator
        event_coordinator_email
    }
}`

export default REGIONAL_DIRECTORS_QUERY;